const portland = portland || {};

(function ($, matchMedia, document, window) {

	portland.main = {

		scrollPositionLast: 0,

		elem: {
			$articles: $('.article-grid'),
			$body: $('body'),
			$footerButton: $('.footer-nav__button'),
			$globalScroll: $('.global-scroll'),
			$mobileNav: $('.mobile-nav'),
			$mobileNavToggleOn: $('.mobile-nav__toggle-menu'),
			$mobileNavToggleOff: $('.sidebar-nav__toggle-menu, .sidebar-nav__backdrop'),
			$primaryButton: $('.primary-nav__button'),
			$searchDesktop: $('.search-desktop'),
			$searchMobile: $('.search-mobile'),
			$searchToggle: $('.mobile-nav__toggle-search, .primary-nav__toggle-search'),
			$sidebarButton: $('.sidebar-nav__button'),
			$sidebarBackdrop: $('.sidebar-nav__backdrop'),
			$sidebarNav: $('.sidebar-nav')
		},

		mql: {
			large: window.matchMedia('(min-width: 640px)'),
			mobile: window.matchMedia('(max-width: 1199px)')
		},

		init: function () {
			this.bindUIActions();
			this.articleHeights();
			this.footerSubmenuReset();
		},

		bindUIActions: function () {
			this.elem.$footerButton.on('click', this.footerSubmenuToggle.bind(this));
			this.elem.$primaryButton.on('click', this.primarySubmenuToggle.bind(this));
			this.elem.$primaryButton.on('mouseleave', e => $(e.currentTarget).blur());
			this.elem.$searchToggle.on('click', this.searchToggle.bind(this));
			this.elem.$mobileNavToggleOn.on('click', this.sidebarNavToggleOn.bind(this));
			this.elem.$mobileNavToggleOff.on('click', this.sidebarNavToggleOff.bind(this));
			this.elem.$sidebarBackdrop.on('focusin', this.sidebarNavToggleOff.bind(this));
			this.elem.$sidebarButton.on('click', this.sidebarSubmenuToggle.bind(this));
			this.mql.mobile.addListener(this.footerSubmenuReset.bind(this));

			$(document).on('keydown', this.sidebarNavEscape.bind(this));
			$(document).on('scroll', this.onScroll.bind(this));
			$(window).on('resize', this.articleHeights.bind(this));
			$(window).on('resize', this.onScroll.bind(this));
		},

		// Equalize Heights of item in article grids
		articleHeights: function() {
			portland.main.elem.$articles.each( function() {
				portland.main.equalizeHeights($(this).find('.introduction__category'));
				portland.main.equalizeHeights($(this).find('.introduction__episode'));
				portland.main.equalizeHeights($(this).find('.introduction__title'));
				portland.main.equalizeHeights($(this).find('.introduction__summary'));
				portland.main.equalizeHeights($(this).find('.introduction__credit-list'));
			});
		},

		equalizeHeights: function(selector) {
			selector.removeAttr('style');
			if (portland.main.mql.large.matches) {
				let tallest = 0;
				selector.each(function() {
					if ($(this).innerHeight() > tallest) {
						tallest = $(this).innerHeight();
					}
				});
				selector.innerHeight(tallest);
			};
		},

		// Reset attributes on footer menus on resize
		footerSubmenuReset: function() {
			if (portland.main.mql.mobile.matches) {
				portland.main.elem.$footerButton.each(function () {
					$(this).attr({
						'aria-label': function (index, currentValue) {
							return (currentValue.indexOf('Open') > -1) ? currentValue.replace('Open', 'Close') : currentValue.replace('Open', 'Open');
						},
						'aria-expanded': 'false',
 						'aria-pressed': 'false',
					})
						.removeAttr('disabled');
					$(this).next('.footer-nav__child-list')
						.attr({ 'aria-hidden': 'true' })
				});
			} else {
				portland.main.elem.$footerButton.each(function () {
					$(this).attr({
						'aria-label': function (index, currentValue) {
							return (currentValue.indexOf('Open') > -1) ? currentValue.replace('Open', 'Close') : currentValue.replace('Open', 'Open');
						},
						'aria-expanded': 'true',
						'aria-pressed': 'true',
						'disabled': 'disabled'
					});
					$(this).next('.footer-nav__child-list')
						.attr({ 'aria-hidden': 'false' })
						.removeAttr('style');
				});
			}
		},

		// Expand/collapse footer child menus (on mobile only)
		footerSubmenuToggle: function(e) {
			e.preventDefault();
			if (portland.main.mql.mobile.matches) {
				let button = $(e.currentTarget);
				button.attr({
					'aria-label': function (index, currentValue) {
						return (currentValue.indexOf('Open') > -1) ? currentValue.replace('Open', 'Close') : currentValue.replace('Close', 'Open');
					},
					'aria-expanded': function (index, currentValue) {
						return (currentValue === 'true') ? 'false' : 'true';
					},
					'aria-pressed': function (index, currentValue) {
						return (currentValue === 'true') ? 'false' : 'true';
					}
				});
				button.next('.footer-nav__child-list')
					.attr({ 
						'aria-hidden': function (index, currentValue) {
							return (currentValue === 'true') ? 'false' : 'true';
						}
					})
					.slideToggle();
			}
		},

		// Adjust fixture of global header when scrolling
		onScroll: function() {
			let scrollPosition = window.pageYOffset || window.document.documentElement.scrollTop;

			if (scrollPosition <= 175) {
				portland.main.elem.$globalScroll.fadeOut();
				portland.main.elem.$mobileNav.removeClass('mobile-nav--is-fixed');
			}

			if (scrollPosition >= 325) {
				portland.main.elem.$globalScroll.fadeIn();
				portland.main.elem.$mobileNav.addClass('mobile-nav--is-fixed');
			} 

			if ((scrollPosition >= 450) && (scrollPosition < portland.main.scrollPositionLast)) {
				portland.main.elem.$mobileNav.addClass('mobile-nav--is-shown');
			} else {
				portland.main.elem.$mobileNav.removeClass('mobile-nav--is-shown');
			}

			portland.main.scrollPositionLast = scrollPosition;
		},

		// Expand/collapse primary child menus
		primarySubmenuToggle: function(e) {
			e.preventDefault();
			let button = $(e.currentTarget);

			portland.main.elem.$primaryButton.each(function() {
				if (this !== e.currentTarget) {
					$(this).attr({
						'aria-label': function (index, currentValue) {
							return currentValue.replace('Close', 'Open');
						},
						'aria-expanded': 'false',
						'aria-pressed': 'false'
					})
						.next('.primary-nav__child-list')
						.attr({ 'aria-hidden': 'true' })
						.slideUp();
				}
			});

			button.attr({
				'aria-label': function (index, currentValue) {
					return (currentValue.indexOf('Open') > -1) ? currentValue.replace('Open', 'Close') : currentValue.replace('Close', 'Open');
				},
				'aria-expanded': function (index, currentValue) {
					return (currentValue === 'true') ? 'false' : 'true';
				},
				'aria-pressed': function (index, currentValue) {
					return (currentValue === 'true') ? 'false' : 'true';
				}
			})
				.next('.primary-nav__child-list')
				.attr({ 
					'aria-hidden': function (index, currentValue) {
						return (currentValue === 'true') ? 'false' : 'true';
					}
				})
				.slideToggle();
		},

		// Expand/collapse desktop search
		searchToggle: function(e) {
			e.preventDefault();
			portland.main.elem.$primaryButton.each(function() {
				$(this).attr({
					'aria-label': function (index, currentValue) {
						return currentValue.replace('Close', 'Open');
					},
					'aria-expanded': 'false',
					'aria-pressed': 'false'
				})
					.next('.primary-nav__child-list')
					.attr({ 'aria-hidden': 'true' })
					.slideUp();
			});

			portland.main.elem.$searchToggle.each(function() {
				$(this).attr({
					'aria-label': function (index, currentValue) {
						return (currentValue.indexOf('Open') > -1) ? currentValue.replace('Open', 'Close') : currentValue.replace('Close', 'Open');
					},
					'aria-expanded': function (index, currentValue) {
						return (currentValue === 'true') ? 'false' : 'true';
					},
					'aria-pressed': function (index, currentValue) {
						return (currentValue === 'true') ? 'false' : 'true';
					}
				});
			});
			$('html, body').animate({ scrollTop: '0' }, 425);
			portland.main.elem.$searchDesktop.slideToggle();
			// .find('.gsc-input').focus()
		},

		// Toggle sidebar menu display
		sidebarNavEscape: function(e) {
			if (e.type === 'keydown') {
				let code = (e.keyCode) ? e.keyCode : e.which;
				if (code === 27) {
					if (portland.main.elem.$sidebarNav.hasClass('is-active')) {
						e.preventDefault();
						portland.main.elem.$body.removeClass('menu-open');
						portland.main.elem.$sidebarNav.removeClass('is-active').attr({ 'aria-hidden': 'true'}).find('[tabindex]').attr({ 'tabindex' : -1 });
					}
				};
			};
		},

		sidebarNavToggleOn: function(e) {
			e.preventDefault();
			portland.main.elem.$body.addClass('menu-open');
			portland.main.elem.$searchMobile.show();
			portland.main.elem.$sidebarNav.addClass('is-active').attr({ 'aria-hidden': 'false'}).find('[tabindex]').attr({ 'tabindex' : 0 });
			portland.main.elem.$sidebarNav.find('.sidebar-nav__toggle-menu').focus();
		},

		sidebarNavToggleOff: function(e) {
			e.preventDefault();
			portland.main.elem.$body.removeClass('menu-open');
			portland.main.elem.$searchMobile.hide();
			portland.main.elem.$sidebarNav.removeClass('is-active').attr({ 'aria-hidden': 'true'}).find('[tabindex]').attr({ 'tabindex' : -1 });
		},

		// Expand/collapse sidebar child menus
		sidebarSubmenuToggle: function(e) {
			e.preventDefault();
			let button = $(e.currentTarget);
			button.attr({
				'aria-label': function (index, currentValue) {
					return (currentValue.indexOf('Open') > -1) ? currentValue.replace('Open', 'Close') : currentValue.replace('Close', 'Open');
				},
				'aria-expanded': function (index, currentValue) {
					return (currentValue === 'true') ? 'false' : 'true';
				},
				'aria-pressed': function (index, currentValue) {
					return (currentValue === 'true') ? 'false' : 'true';
				}
			});
			button.next('.sidebar-nav__child-list')
				.attr({ 
					'aria-hidden': function (index, currentValue) {
						return (currentValue === 'true') ? 'false' : 'true';
					}
				})
				.slideToggle();
		}

	};

}(window.jQuery, window.matchMedia, window.document, window));

const ready = () => {
	portland.main.init();
};

window.addEventListener('DOMContentLoaded', ready, false);
$(document).foundation();
